import api from '@config/api'
import { useQuery } from 'react-query'
import { useFormMutationHandler } from '@utils/useFormMutationHandler'
import { IFormMutationHandlerProps } from '@interfaces/default/IDefault'
import { useQueryConfig } from './useQueryConfig'
import {
    IRequestCreateUser,
    IRequestDeleteUser,
    IRequestGetAllUsers,
    IRequestUpdatePassword,
    IRequestUpdateUser,
    IResponseGetAllUsers,
    IResponseGetUserByID,
    IUserID,
} from '@apiinterface/IUser'

interface IUseCreateUser
    extends IFormMutationHandlerProps<IRequestCreateUser> {}

interface IUseUpdateUser
    extends IUserID,
        IFormMutationHandlerProps<IRequestUpdateUser> {}

interface IUseUpdateUserPassword
    extends IUserID,
        IFormMutationHandlerProps<IRequestUpdatePassword> {}

interface IUseDeleteUserByID
    extends IUserID,
        IFormMutationHandlerProps<IUserID> {}
interface IUseBulkDeleteUser
    extends IFormMutationHandlerProps<IRequestDeleteUser> {}

const User = {
    useGetAllUsers: ({
        limit = 10,
        orderby = 'id',
        order = 'desc',
        page = 1,
        search = '',
        role,
    }: IRequestGetAllUsers) =>
        useQuery(
            'getAllUsers',
            async () => {
                try {
                    const res = await api.get('/users', {
                        params: {
                            limit,
                            orderby,
                            order,
                            page,
                            search,
                            role,
                        },
                    })
                    return res.data.body as IResponseGetAllUsers
                } catch (error) {
                    return Promise.reject(error)
                }
            },
            useQueryConfig
        ),
    useGetUserByID: ({ user_id }: IUserID) =>
        useQuery(
            'getUserByID' + user_id,
            async () => {
                try {
                    const res = await api.get(`/users/${user_id}`)
                    return res.data.body as IResponseGetUserByID
                } catch (error) {
                    return Promise.reject(error)
                }
            },
            useQueryConfig
        ),

    useCreateUser: ({ form, aftersuccess }: IUseCreateUser) => {
        return useFormMutationHandler({
            form,
            pathWithMethod: ['/users', 'post'],
            aftersuccess,
        })
    },
    useUpdateUser: ({ form, user_id, aftersuccess }: IUseUpdateUser) => {
        return useFormMutationHandler({
            form,
            pathWithMethod: [`/users/${user_id}`, 'put'],
            aftersuccess,
        })
    },
    useUpdateUserPassword: ({
        form,
        user_id,
        aftersuccess,
    }: IUseUpdateUserPassword) => {
        return useFormMutationHandler({
            form,
            pathWithMethod: [`/users/password/${user_id}`, 'put'],
            aftersuccess,
        })
    },

    useDeleteUserByID: ({ user_id, aftersuccess }: IUseDeleteUserByID) => {
        return useFormMutationHandler({
            pathWithMethod: [`/users/${user_id}`, 'delete'],
            aftersuccess,
        })
    },
    useDeleteUser: ({ form, aftersuccess }: IUseBulkDeleteUser) => {
        return useFormMutationHandler({
            pathWithMethod: [`/users}`, 'delete'],
            aftersuccess,
            form,
        })
    },
}

export default User
